// eslint-disable-next-line @wix/thunderbolt/no-internal-import
import type { Adapter } from '@wix/app-settings-client/dist/src/domain'
import { appClient, Scope } from '@wix/app-settings-client'
import type { MetricsReporter } from '@wix/thunderbolt-becky-types'
import type { BeckyModel } from '@wix/thunderbolt-becky-root/dist'
import { ooiStyleParamsUtil } from '@wix/thunderbolt-commons'

export class AppSettings implements Adapter {
	appDefId: string
	instanceId: string
	externalId: string
	signedInstance: any

	constructor({ appDefId, instanceId, externalId }: { appDefId: string; instanceId: string; externalId: string }) {
		this.appDefId = appDefId
		this.instanceId = instanceId
		this.externalId = externalId
	}

	getAppDefId(): string {
		return this.appDefId
	}

	getInstanceId(): string {
		return this.instanceId
	}

	async getExternalId(): Promise<string> {
		return this.externalId
	}

	async setExternalId(_id: string): Promise<void> {}

	triggerSettingsUpdated(_data: any, _scope: Scope): void {}

	onSettingsUpdated(_scope: Scope, _cb: (k: object) => void): void {}
}

export const resolveAppSettings = async (
	referenceId: string,
	appDefId: string,
	instanceId: string,
	metricsReporter: MetricsReporter
) => {
	return metricsReporter.runAsyncAndReport(async () => {
		try {
			const appSettings = appClient({
				scope: Scope.COMPONENT,
				adapter: new AppSettings({
					appDefId,
					instanceId,
					externalId: referenceId,
				}),
			})
			return appSettings.getAll()
		} catch (e) {
			metricsReporter.reportError(
				new Error(
					`Failed to get app settings for appDefId: ${appDefId} with externalId: ${referenceId} and instanceId:s ${instanceId}, error: ${e}`
				)
			)
		}
	}, 'app settings fetcher')
}

const getAppsInstalled = (clientSpecMap: BeckyModel['clientSpecMap']) => {
	return Object.values(clientSpecMap).map((installedApplication: any) => {
		return {
			appDefinitionId: installedApplication.appDefinitionId,
			instanceId: installedApplication.instanceId,
		}
	})
}

export const resolveWidgetsWithAppSettings = async (
	widgetsWithReferenceId: Array<{ widgetId: string; referenceId: string }> | undefined,
	clientSpecMap: BeckyModel['clientSpecMap'],
	metricsReporter: MetricsReporter
) => {
	const widgetsWithAppSettings: Record<string, any> = {}
	if (widgetsWithReferenceId?.length) {
		const appsInstalled: Array<{ appDefinitionId: string; instanceId: string }> = getAppsInstalled(clientSpecMap)
		await Promise.all(
			widgetsWithReferenceId.map(async (widget) => {
				const { widgetId, referenceId } = widget
				if (ooiStyleParamsUtil.shouldOverrideStyleParams(widgetId)) {
					const appDefinitionId = ooiStyleParamsUtil.getAppDefIdForWidget(widgetId)
					const instanceId = appsInstalled.find(
						(appInstalled) => appInstalled.appDefinitionId === appDefinitionId
					)?.instanceId
					const appSettings = await resolveAppSettings(
						referenceId,
						appDefinitionId,
						// @ts-ignore
						instanceId,
						metricsReporter
					)
					widgetsWithAppSettings[`${widgetId}-${referenceId}`] = appSettings
				}
			})
		)
	}
	return widgetsWithAppSettings
}
